import type { AgendaEntry } from '../types/content'

export const agenda: AgendaEntry[] = [
  {
    id: 'stage-radio',
    day: '17',
    month: 'sept.',
    type: 'Stage',
    title: 'Stage radiotéléphonie et phraséologie',
    place: 'Blois — Le Breuil',
  },
  {
    id: 'coupe-precision',
    day: '21',
    month: 'sept.',
    type: 'Compétition',
    title: 'Coupe fédérale de précision d’atterrissage',
    place: 'Vichy — Charmeil',
  },
  {
    id: 'festi-ulm',
    day: '26',
    month: 'sept.',
    type: 'Événement',
    title: "Festi'ULM — rassemblement national",
    place: 'Blois',
  },
  {
    id: 'stage-mecanique',
    day: '4',
    month: 'oct.',
    type: 'Stage',
    title: 'Stage mécanique moteur deux temps',
    place: 'Toulouse — Bourg-Saint-Bernard',
  },
  {
    id: 'stage-instructeur',
    day: '12',
    month: 'oct.',
    type: 'Stage',
    title: 'Formation instructeur — module pédagogie',
    place: 'Chalon-sur-Saône',
  },
]

export const agendaFilters: Array<AgendaEntry['type'] | 'Tout'> = [
  'Tout',
  'Compétition',
  'Stage',
  'Événement',
]
